//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';

export default {
  name: 'DpCheckboxGroup',
  mixins: [Emitter],
  props: {
    /**
     * Model
     * @model
     */
    value: { type: Array, default: () => null },
    inline: { type: Boolean, default: false },
  },
};
